module.exports = "/_next/static/images/Plan-2-03113afba94ddcf41b3042f3f31fc0eb.png";